import { put, takeEvery, call } from "redux-saga/effects";

import * as apis from "../../network/apis/offers";
import {
  getOfferDetailsResponse,
  getOffersListResponse,
  getCallToActionsResponse,
  getOfferDetailsRequest,
  getOffersListRequest,
} from "./slice";
import { ROUTES_PATHS } from "../../utils/RoutesPaths";
import { showSnackMsg } from "../../utils/Helpers";
import {
  clearSkeletonObject,
  setCanShowEmptyState,
  setSkeletonObject,
} from "../Loader/slice";

export function* createOfferSaga({ payload }) {
  try {
    yield call(apis.createOffer, payload.data);
    yield showSnackMsg(payload.successMsg, "success");
    yield payload.navigate(ROUTES_PATHS.offers);
  } catch (err) {
    yield showSnackMsg(err.response?.data?.message);
  }
}

export function* getOffersListSaga({ payload }) {
  try {
    yield put(getOffersListResponse({ offers: [], meta: {} }));
    yield put(setSkeletonObject({ field: "offers", value: true }));
    const response = yield call(apis.getOffers, payload);
    const meta = {
      currentPage: +response.headers["current-page"],
      count: +response.headers["total-count"],
      pages: +response.headers["total-pages"],
    };
    const offers = response.data?.offers;
    yield put(getOffersListResponse({ offers, meta }));
    yield put(setSkeletonObject({ field: "offers", value: false }));
    if (offers.length === 0) {
      yield put(setCanShowEmptyState(true));
    } else {
      yield put(setCanShowEmptyState(false));
    }
  } catch (err) {
    yield put(setSkeletonObject({ field: "offers", value: false }));
    yield put(setCanShowEmptyState(true));
    yield showSnackMsg(err.response?.data?.message);
  }
}

export function* getOfferDetailsSaga({ payload }) {
  try {
    const { id, isEdit } = payload;
    yield put(setSkeletonObject({ field: "offers", value: true }));
    if (!!isEdit) {
      // show loader if edit offer mode
      yield put(clearSkeletonObject());
    }
    const response = yield call(apis.getOfferDetails, id);
    const offer = response.data?.offer;
    yield put(getOfferDetailsResponse(offer));
    yield put(setSkeletonObject({ field: "offers", value: false }));
    if (!offer) {
      yield put(setCanShowEmptyState(true));
    } else {
      yield put(setCanShowEmptyState(false));
    }
  } catch (err) {
    yield put(setSkeletonObject({ field: "offers", value: false }));
    yield put(setCanShowEmptyState(true));
    yield showSnackMsg(err.response?.data?.message);
  }
}

export function* editOfferSaga({ payload }) {
  try {
    const { id, data, navigate, successMsg, listParams } = payload;
    yield call(apis.editOffer, { id, data });
    yield showSnackMsg(successMsg, "success");
    if (!!navigate) {
      yield navigate(ROUTES_PATHS.offers);
    } else {
      yield put(getOffersListRequest(listParams));
    }
  } catch (err) {
    yield showSnackMsg(err.response?.data?.message);
  }
}

export function* editHotOfferStatusSaga({ payload }) {
  const { id, data, successMsg } = payload;
  try {
    yield call(apis.editOffer, { id, data });
    yield showSnackMsg(successMsg, "success");
    yield put(getOfferDetailsRequest({ id }));
  } catch (err) {
    yield showSnackMsg(err.response?.data?.message);
  }
}

export function* editServiceOfferStatusSaga({ payload }) {
  const { id, data, successMsg } = payload;
  try {
    yield call(apis.editOffer, { id, data });
    yield showSnackMsg(successMsg, "success");
    yield put(getOfferDetailsRequest({ id }));
  } catch (err) {
    yield showSnackMsg(err.response?.data?.message);
  }
}

export function* deleteOfferSaga({ payload }) {
  try {
    const { id, successMsg, navigateToList, listParams } = payload;
    yield call(apis.deleteOffer, id);
    yield showSnackMsg(successMsg, "success");
    if (navigateToList) {
      yield payload.navigate(ROUTES_PATHS.offers);
    } else {
      yield put(getOffersListRequest(listParams));
    }
  } catch (err) {
    yield showSnackMsg(err.response?.data?.message);
  }
}

export function* publishOfferSaga({ payload }) {
  try {
    const { id, data, successMsg, fromList, listParams } = payload;
    yield call(apis.editOffer, { id, data });
    yield showSnackMsg(successMsg, "success");
    if (fromList) {
      yield put(getOffersListRequest(listParams));
    } else {
      yield put(getOfferDetailsRequest({ id }));
    }
  } catch (err) {
    yield showSnackMsg(err.response?.data?.message);
  }
}

export function* getCallToActionsSaga({ payload }) {
  try {
    const response = yield call(apis.getCallToActions, payload);
    yield put(
      getCallToActionsResponse({ callToActions: response.data.call_to_actions })
    );
  } catch (err) {
    yield showSnackMsg(err.response?.data?.message);
  }
}

export default function* OffersSagas() {
  yield takeEvery("offer/createOfferRequest", createOfferSaga);
  yield takeEvery("offer/getOffersListRequest", getOffersListSaga);
  yield takeEvery("offer/getOfferDetailsRequest", getOfferDetailsSaga);
  yield takeEvery("offer/deleteOfferRequest", deleteOfferSaga);
  yield takeEvery("offer/editOfferRequest", editOfferSaga);
  yield takeEvery("offer/publishOfferRequest", publishOfferSaga);
  yield takeEvery("offer/getCallToActionsRequest", getCallToActionsSaga);
  yield takeEvery("offer/editHotOfferStatusRequest", editHotOfferStatusSaga);
  yield takeEvery("offer/editServiceOfferStatusRequest", editServiceOfferStatusSaga);
}
